export const markSessionExpired = () => {
    globalThis.__APP_SESSION_EXPIRED__ = true;
};

export const isSessionExpired = () => {
    return globalThis.__APP_SESSION_EXPIRED__ === true;
};

export const clearSessionExpired = () => {
    globalThis.__APP_SESSION_EXPIRED__ = false;
}; 